import React, { FC } from 'react';
import { Box, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { LocationPicker } from 'components/Pickers';
import { RemoveIcon } from 'components';
import { ClientLocationFragment } from 'api';

import { UserSearchesV2Filter } from '../type';

interface Props {
  filter: UserSearchesV2Filter;
  setFilter: (filter: UserSearchesV2Filter) => void;
  setSelectedLocations: (locations: Array<Partial<ClientLocationFragment>>) => void;
}

const Locations: FC<Props> = ({ filter, setFilter, setSelectedLocations }) => {
  const { t } = useTranslation();
  const { location_ids } = filter;

  function onClickRemove() {
    setFilter({ ...filter, location_ids: [] });
  }

  return (
    <Grid container alignItems="center">
      <Grid xs={2}>
        <Typography variant="body2">{t('admin:locations')}</Typography>
      </Grid>
      <Grid xs={9}>
        <LocationPicker
          selectedLocationIds={location_ids}
          onLocationChange={(ids, locations) => {
            setSelectedLocations(locations);
            setFilter({ ...filter, location_ids: ids });
          }}
        />
      </Grid>
      {!!location_ids.length && (
        <Grid xs={1}>
          <Box pl={1}>
            <RemoveIcon onClick={onClickRemove} />
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default Locations;
